// extracted by mini-css-extract-plugin
export default {"imgdiv":"db9558889b _89777b9679","img":"_3c1c0985ef f11775bf33"};